"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/Integrations/actions");

var _Integration = _interopRequireDefault(require("./Integration"));

var initialState = (0, _immutable.Map)({
  integrations: new _immutable.Map()
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchInstalledActionTypes.SUCCESS, function (state, action) {
  return state.set('integrations', action.payload.data.map(function (integration) {
    return new _Integration.default(integration);
  }));
}), initialState);

exports.default = _default;
module.exports = exports.default;